export function useNewsletter() {
  const email = useState('email', () => '')
  const subscribe = useState('subscribe', () => undefined)
  const confirmed = useState('confirmed', () => false)

  const { show: showNotification } = useNotification()

  const { email: emailOnCart } = useCart()
  const { isLoggedIn, customerData } = useAccount()
  const watchersEnabled = ref<boolean>(false)

  if (!watchersEnabled.value) {
    watch(emailOnCart, (val) => {
      if (val) {
        email.value = val
      }
    }, { immediate: true })

    watch(isLoggedIn, () => {
      if (isLoggedIn) {
        email.value = (customerData.value as { email?: string } | undefined)?.email || ''
      }
    }, { immediate: true })

    watchersEnabled.value = true
  }

  const subscribeToNewsletterLoading = ref(false)
  const subscribeToNewsletterCalled = ref(false)
  const subscribeToNewsletterError = ref()

  const confirm = async () => {
    if (confirmed.value || !subscribe.value || !email.value) {
      return true
    }

    subscribeToNewsletterLoading.value = true
    subscribeToNewsletterCalled.value = true

    const clientOptions = useGraphqlCustomerClient()

    const result = await useGraphqlMutation('subscribeEmailToNewsletter', { email: email.value }, {
      ...clientOptions,
      fetchOptions: {
        ...clientOptions.fetchOptions,
        // Keep the request alive even if the browser navigates away right
        // after this call (e.g. checkout redirecting to the PSP's domain),
        // so the subscription still completes instead of being aborted.
        keepalive: true,
      },
    })

    subscribeToNewsletterLoading.value = false

    if (result.errors?.length) {
      // The customer is already subscribed to the newsletter. This is not a
      // failure from the customer's perspective (they wanted to be
      // subscribed and already are), so treat it as a successful
      // confirmation instead of surfacing an error and blocking checkout.
      const alreadySubscribed = result.errors.some(
        error => error.extensions?.category === 'graphql-already-exists',
      )

      if (alreadySubscribed) {
        confirmed.value = true
        return true
      }

      subscribeToNewsletterError.value = result.errors
      console.error('subscribeToNewsletterException', result.errors)

      showNotification({
        type: 'error',
        message: useMessageHandler(result.errors[0]?.message || ''),
      })

      return false
    }

    confirmed.value = true

    return true
  }

  return {
    subscribe,
    confirmed,
    subscribeToNewsletterLoading,
    subscribeToNewsletterError,
    subscribeToNewsletterCalled,
    confirm,
    email,
  }
}
